import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useKeyboardShortcuts } from "../../utils/keyboardShortcuts";
import KeyboardShortcutsHelp from "../molecules/KeyboardShortcutsHelp";
import NavigationBar from "../organisms/NavigationBar";

/**
 * MainLayout - Main application layout with navigation
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Page content
 * @param {boolean} props.showEnvWarning - Show environment warning
 */
const MainLayout = ({ children, showEnvWarning = false }) => {
  const navigate = useNavigate();

  // Register global navigation shortcuts
  useKeyboardShortcuts({
    "g d": () => navigate("/"),
    "g i": () => navigate("/intake"),
    "g w": () => navigate("/workshop"),
    "g h": () => navigate("/help"),
  });

  // Track page views and provide focus management for keyboard shortcuts
  useEffect(() => {
    // Set focus to the main content area when page changes
    const mainContent = document.querySelector("main");
    if (mainContent) {
      mainContent.setAttribute("tabindex", "-1");
      mainContent.focus();
    }

    // Add a global class to indicate keyboard shortcut availability
    document.body.classList.add("shortcuts-enabled");

    return () => {
      document.body.classList.remove("shortcuts-enabled");
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-[#0f1418]">
      <NavigationBar showEnvWarning={showEnvWarning} />
      <main className="flex-grow outline-none" tabIndex="-1">
        {children}
      </main>
      <KeyboardShortcutsHelp />
    </div>
  );
};

export default MainLayout;
